import React from "react";
import css from "./IconButton.module.css";

import cn from "classnames";

type Props = {
    onClick: () => void;
    iconSrc: string;
    outline?: boolean;
    size?: "small" | "medium";
};

export const IconButton: React.FC<Props> = ({
    onClick,
    iconSrc,
    outline = false,
    size = "medium",
}) => {
    return (
        <button className={cn(css.main, { [css.outline]: outline }, css[size])} onClick={onClick}>
            <img src={iconSrc} alt="icon" />
        </button>
    );
};
